// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"202":"21f710e5","418":"2c7aa53b","453":"20b0c8c6"}[chunkId] + ".chunk.js";
};